import React from 'react';
import { FaThermometerHalf } from 'react-icons/fa';

export default function TemperatureGuidelines() {
  return (
    <div className="w-full col-span-9  p-5 bg-white border border-gray-100 rounded-2xl shadow-sm">
      {/* Title */}
      <h3 className="text-sm font-bold text-gray-900 mb-4">
        Temperature Guidelines
      </h3>

      {/* Guidelines Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 border border-gray-100/80 rounded-xl overflow-hidden divide-y md:divide-y-0 md:divide-x divide-gray-100">
        
        {/* Hot Holding Card */}
        <div className="p-4 flex flex-col gap-1.5 bg-white">
          <div className="flex items-center gap-2 text-rose-500 font-bold text-xs tracking-wide">
            <FaThermometerHalf className="text-sm" />
            <span>Hot Holding</span>
          </div>
          <div className="flex flex-col gap-0.5 pl-5">
            <p className="text-xs font-semibold text-gray-700">
              Keep food at 63°C or above
            </p>
            <p className="text-xs text-gray-400 font-medium">
              Action required if below 63°C
            </p>
          </div>
        </div>

        {/* Cold Holding Card */}
        <div className="p-4 flex flex-col gap-1.5 bg-white">
          <div className="flex items-center gap-2 text-blue-500 font-bold text-xs tracking-wide">
            <FaThermometerHalf className="text-sm" />
            <span>Cold Holding</span>
          </div>
          <div className="flex flex-col gap-0.5 pl-5">
            <p className="text-xs font-semibold text-gray-700">
              Keep food at 8°C or below
            </p>
            <p className="text-xs text-gray-400 font-medium">
              Action required if above 8°C
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
